
import { Base64 } from 'js-base64'
import { LOGIN_URL, APPLICATION_ID } from '../config'

export function goLoginPage () {
  const from = window.location.href
  window.location.href = LOGIN_URL + '?from=' + Base64.encodeURI(from) + '&id=' + APPLICATION_ID
}
